module.exports = __webpack_public_path__ + "img/haze.e898eceb.png";